import { render } from "./SocialNetworks.vue?vue&type=template&id=19e172c0&scoped=true"
import script from "./SocialNetworks.vue?vue&type=script&lang=js"
export * from "./SocialNetworks.vue?vue&type=script&lang=js"

import "./SocialNetworks.vue?vue&type=style&index=0&id=19e172c0&lang=scss&scoped=true"

import exportComponent from "/project/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19e172c0"]])

export default __exports__